/* eslint-disable no-inline-styles/no-inline-styles */
import React, { useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import StepIcon from 'Assets/png/personalised_onboarding/step3.png';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import { advSearchState } from 'Stores/advSearch';

const {
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
} = CONSTANTS;
const {
  EMAIL_CAMPAIGN_LIST,
  TARGETED_ACCOUNTS,
  AD_AUDIENCE_LIST,
} = PERSONALIED_ONBOARDING_FLOWS;
const { LB_GOAL_CURRENT_STEP_VALUE } = MX_PERSONALISED_ONBOARDING_EVENTS;
const { EXPORT } = LB_GOAL_CURRENT_STEP_VALUE;

const TITLE = {
  EMAIL_CAMPAIGN_LIST: 'Goal : Email Campaign List - Step 3',
  TARGETED_ACCOUNTS: 'Goal : Build Target Accounts list - Step 3',
  AD_AUDIENCE_LIST: 'Goal : Build Custom Ad Audience - Step 3',
};

const StepThreeTopWrapper = observer(() => {
  const { isPersonalisedOnboardingFlow } = personalisedOnboardingState;
  const handleCloseClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { closed: EXPORT });
    personalisedOnboardingState.clearOnboardingFlow();
  };
  return (
    <>
      <div className="sharp-point" />
      <div className="close-icon-wrapper">
        <CloseIcon className="close-icon" onClick={e => handleCloseClick()} />
      </div>
      <div className="onboarding-img-wrapper">
        <img src={StepIcon} alt="StepIcon" />
      </div>
      <div className="onboarding-title-wrapper">
        <div className="title">{TITLE[isPersonalisedOnboardingFlow]}</div>
        <div className="progress-bar">
          <div className="progress-bar-fill" />
        </div>
      </div>
    </>
  );
});

const EmailCampaignList = observer(props => {
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.querySelector(
      '.right-section .adv-contact-export',
    );

    let topPosition = 0;
    let leftPosition = 0;

    if (element) {
      const boundries = element.getBoundingClientRect();
      const { top, left } = boundries;
      topPosition = top + 48;
      leftPosition = left - 50;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleExportClick = () => {
    document.getElementById('exportSelectedContact').click();
  };

  return (
    <div
      className="onboarding-flow-step-popup onboarding-flow-step-three-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepThreeTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Export to CSV/CRM</div>
        <div className="description">
          <span>
            You can export to CSV or integrate your CRM and transfer contact
            lists instantly.
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div
            className="action-btn btn-enabled"
            onClick={e => handleExportClick(e)}
          >
            Export
          </div>
        </div>
      </div>
    </div>
  );
});

const TargetAccountList = observer(props => {
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.querySelector(
      '.right-section .adv-company-export',
    );

    let topPosition = 0;
    let leftPosition = 0;

    if (element) {
      const boundries = element.getBoundingClientRect();
      const { top, left } = boundries;
      topPosition = top + 48;
      leftPosition = left - 10;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleExportClick = () => {
    document.getElementById('exportSelectedCompany').click();
  };

  const handleFindMatchingContactClick = () => {
    document.getElementById('findMatchingContacts').click();
  };

  return (
    <div
      className="onboarding-flow-step-popup onboarding-flow-step-three-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepThreeTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Export to CSV/CRM</div>
        <div className="description">
          <span>You can export to CSV or integrate your CRM</span>
        </div>
        <div className="action-btn-wrapper">
          <div
            className="action-btn btn-enabled"
            onClick={e => handleExportClick(e)}
          >
            Export
          </div>
        </div>
        <div className="divider">
          <span className="text-wrap">OR</span>
          <span className="line-wrap" />
        </div>
        <div className="info-title">Find matching contacts</div>
        <div className="description">
          <span>
            This allows you to find all contacts from the selected companies
            instantly
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div
            className="action-btn btn-enabled"
            onClick={e => handleFindMatchingContactClick(e)}
          >
            Find Matching Contacts
          </div>
        </div>
      </div>
    </div>
  );
});

const AdAudienceList = observer(props => {
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.querySelector(
      '.right-section .adv-company-export',
    );

    let topPosition = 0;
    let leftPosition = 0;

    if (element) {
      const boundries = element.getBoundingClientRect();
      const { top, left } = boundries;
      topPosition = top + 48;
      leftPosition = left - 50;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleExportClick = () => {
    document.getElementById('exportSelectedCompany').click();
  };

  return (
    <div
      className="onboarding-flow-step-popup onboarding-flow-step-three-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepThreeTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Export target list</div>
        <div className="description">
          <span>
            You can export the list of companies with linkedin URLs into the
            format you prefer.
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div
            className="action-btn btn-enabled"
            onClick={e => handleExportClick(e)}
          >
            Export
          </div>
        </div>
      </div>
    </div>
  );
});

const OnboardingStepThreePopup = observer(props => {
  const { isPersonalisedOnboardingFlow } = personalisedOnboardingState;

  return ReactDOM.createPortal(
    isPersonalisedOnboardingFlow === EMAIL_CAMPAIGN_LIST ? (
      <EmailCampaignList />
    ) : isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ? (
      <TargetAccountList />
    ) : isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST ? (
      <AdAudienceList />
    ) : (
      ''
    ),
    document.getElementById('portal-dom-root'),
  );
});

export { OnboardingStepThreePopup };
export default OnboardingStepThreePopup;
